function getDomain(hostname: string = window.location.hostname): string {
  const SUBDOMAIN_REGEX = /.*\.(.*?\.(?:com|net))/;
  const matches = SUBDOMAIN_REGEX.exec(hostname);
  if (matches === null) {
    return hostname;
  }
  return matches[1];
}

export const IS_LOCAL = !window.location.origin.includes("abcmouse.com");

export const AOFL_PRODUCT_UUIDS = {
  ABCMOUSE: "2d6e4e3e-3711-499b-93e3-1919aac44a27",
} as const;

export const getBaseURL = (): string => {
  if (window.location.origin.includes("dev")) {
    return "https://web.dev.abcmouse.com";
  } else if (window.location.origin.includes("stg")) {
    return "https://stg.abcmouse.com";
  }
  return "https://www.abcmouse.com";
};

export const IS_OLD_PROD = window.location.origin.includes("new.abcmouse.com");

export const events = {
  EV_CAMPAIGN_ATTRIBUTION: "@seo:campaignAttribution",
  EV_CAMPAIGN_ATTRIBUTION_LOG: "@seo:campaignAttributionLog",
  EV_ELEMENT_CLICKED: "@seo:linkClick",
  EV_EMAIL_LINK_CLICKED: "@StormPostMailingClick",
  EV_PAGE_LOADED: "@seo:pageLoad",
  EV_VALIDATE_LOGIN: "@seo:validatelogin",
} as const;

export const LOCAL_STORAGE_KEYS = {
  AOFL_TOKEN: "aofl_token",
  DEVICE_ID: "device_id",
} as const;

export const LOG_LEVEL = {
  I: "info",
  E: "error",
} as const;

export const COOKIE_KEYS = {
  CAMPAIGN_INFO: "s_cid_info",
  CAMPAIGN_TAG: "s_cid",
  CAMPAIGN_TAG2: "s_cid2",
  CAMPAIGN_TAG3: "original_s_cid",
  CAMPAIGN_VARS: "s_cid_vars",
  DIM3: "dim_3",
} as const;

export const COOKIE_CONFIG = {
  secure: location.protocol === "https:",
  domain: getDomain(),
  expires: 365,
} as const;

export const QUERY_PARAM_KEYS = {
  EMAIL_CLICK: "_0c83",
} as const;

export const srcTagWhitelist: string[] = [
  "sem:goog:lp:games:1",
  "sem:goog:lp:prog:k",
  "sem:goog:lp:prog:pk",
];
